var keyboardKeyNames = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  SPACE: ' ',
  ENTER: 'Enter',
  END: 'End',
  HOME: 'Home',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  ESCAPE: 'Escape',
  TAB: 'Tab'
};

export { keyboardKeyNames as default };
//# sourceMappingURL=keyboardKeyNames.js.map
